export class SheetBase {
  grade: string = ""
  name: string = ""
  curriculum_id: string = ""
  subject_name: string = ""
  exec_date: string = ""
  grade_cache: string = ""
  verify_count: number = null
  verify_count_cache: number = null
  is_sort_answer_image_enable: boolean = false
  is_mask_student_info: boolean = false
}

export class Examinee{
  id: number | null
  student_no: number | null
  student_no_character: string
  student_name: string
  room_name: string
  addition: string

  constructor(examinee: any){
    this.id = examinee.id;
    this.student_no = examinee.student_no == undefined ? null : examinee.student_no;
    this.student_no_character = examinee.student_no_character == undefined ? null : examinee.student_no_character;
    this.student_name = examinee.student_name;
    this.room_name = examinee.room_name;
    this.addition = examinee.addition;
  }
}

export class Curriculum {
  id: number
  name: string
  constructor(curriculum: any){
    this.id = curriculum.id;
    this.name = curriculum.name;
  }
}
